import common from './common'
import { REPORT_PARAMS, SDK_PRODUCT } from '@/config/dataMap'
const vip_version = REPORT_PARAMS.vip_version
const report_version = REPORT_PARAMS.report_version
const show_from = REPORT_PARAMS.show_from

const chargePageSubShowKfmt =
  'duba_newvip_paypage_subshow:6303 page_num:byte sub_show:int version:byte show_from:int vip_version:int product_id:int'
const chargePagShowKfmt =
  'duba_newvip_paypage_source:6302 page_num:byte version:byte show_from:int vip_version:int product_id:int'
const lifetimeVip = 'duba_jgpdf_hd:7179 pageshow:int click:int ver:int product_id:int usertype:byte'

export default {
  API: {
    method1 () {
    }
  },
  REPORT: {
    reportChargePageSubShow (params) {
      const info = {
        page_num: 0,
        sub_show: 0,
        show_from,
        version: report_version,
        vip_version,
        product_id: SDK_PRODUCT.id
      }
      return common.REPORT.client_report_by_kfmt(chargePageSubShowKfmt, common.API.replaceObj(info, params))
    },
    reportChargePageShow (params) {
      const info = {
        page_num: 0,
        show_from,
        version: report_version,
        vip_version,
        product_id: SDK_PRODUCT.id
      }
      return common.REPORT.client_report_by_kfmt(chargePagShowKfmt, common.API.replaceObj(info, params))
    },
    reportChargeLifetimeVipPage (params) {
      const info = {
        pageshow: 0,
        click: 0,
        usertype: 0,
        ver: report_version,
        product_id: SDK_PRODUCT.id
      }
      return common.REPORT.client_report_by_kfmt(lifetimeVip, common.API.replaceObj(info, params))
    }
  }
}
